<template>
    <div>
        <div class="row">
            <div v-if="!isShowResult" class="wrap-left col-md-3">
                <div v-if="isSubmitExcercise && dataDetailExcercise.typeExcercise == 1">Còn lại {{ formatTime() }}</div>
                <div class="status-save-data" v-if="isSaveData && statusSave == 2">
                    Đang lưu ...
                </div>
                <div class="status-save-data" v-if="statusSave == 3">
                    Đã lưu
                </div>
                <div class="list-question-number margin-top-10">
                    <div class="">
                        <div @click="handleClickQuestion(item)" class="col-md-2 question-item-number"
                            :class="{ 'is-choose': item == itemSelected && !item.isCheck, 'is-check': item.isCheck, 'is-fill': (item.answer || item.listAnswer.length > 0) && !item.isCheck }"
                            v-for="(item, index) of this.dataUserWork" :key="index">
                            {{ item.questionNumber }}
                        </div>

                    </div>
                    <a v-if="isSubmitExcercise" :disabled="isSaveData && statusSave == 2" href="javascript:;"
                        @click="handSubmitExcercise"
                        class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add margin-top-10">
                        Nộp bài
                    </a>
                </div>
            </div>

            <div v-if="questionSelected" class="wrap-right col-md-9">
                <div v-if="questionSelected.questionId>0" class="wrap-content-question">
                    <PreviewQuestion ref="PreviewQuestion" :id="`question_${0}`" :dataSource="questionSelected"
                        :location="0" :valCorrectOld="itemSelected.valCorrect" :questions="[questionSelected]"
                        @getResultQuestion="getResultQuestion" :isDontShowResultSaved="!isShowResult"
                        @changeAnswerEdittorCK="changeAnswerEdittorCK"
                        @writedAnswer="writedAnswer" />
                </div>
                <div v-else class="wrap-content-question">
                    <div class="name-question">
                        <div v-html="questionSelected.content">
                        </div>
                    </div>
                    <div v-for="(item, indexanswers) of questionSelected.answers" :key="indexanswers">
                        <MultipleChoiceNew :dataSource="item"
                                    :nameField="`answer_${questionSelected.questionId}`" :location="indexanswers" :parent="questionSelected"
                                    :valueSelected="itemSelected.answer" :answerContent="itemSelected.answerContent"
                                    :statusUserExcercise="statusUserExcercise" @changeAnswer="changeAnswer" />
                    </div>
                    <div v-if="!isSubmitExcercise || isShowResult" class="">
                        <b-tabs content-class="mt-3 col-md-12">
                            <b-tab title="Hướng dẫn">
                                <div class="exercise-detail__guide__content font-size-16 primary-color-txt">
                                    <div class="guide__content"
                                        v-html="questionSelected && questionSelected.guideContent ? questionSelected.guideContent : ''">
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Lời giải chi tiết">
                                <div class="guide__content"
                                    v-html="questionSelected && questionSelected.answerDetail ? questionSelected.answerDetail : ''">
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>

                <div v-if="!isShowResult" class="row justify-content-center margin-top-10">
                    <img @click="handlePrevQuestion" class="icon-arrow" src="@/assets/img/arrow-left.png" />
                    <button type="button" @click="handleCheckItem"
                        class="btn btn-ischeck border-rd-20 font-size-16 form-30h font-sanpro-semibold line-height-1">
                        Đánh dấu
                    </button>
                    <img @click="handleNextquestion" class="icon-arrow" src="@/assets/img/arrow-right.png" />
                </div>

            </div>

            <div v-if="isShowResult" class="col-md-3">
                <div v-if="dataDetailExcercise.typeUploadExcercise == 3">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h5 v-if="!this.isShowResult">Thông tin đề</h5>
                        </div>
                        <div class="col-md-12 text-center">
                            <strong>Điểm</strong>

                        </div>
                        <div class="col-md-12 text-center">
                            <strong class="result-point">{{ userExcerciseClassSchool.point
                                }}</strong>
                        </div>
                        <div class="col-md-12 ">
                            <div class="display-flex justify-content-space-between">
                                <div class="title-complete">
                                    <strong>Thời gian hoàn thành</strong>
                                </div>
                                &nbsp;
                                &nbsp;
                                <div class="time-complete">
                                    {{ formatTimeResult() }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <span class="color-blue"></span> Số câu đúng: {{ countQuestionTrue }}
                        </div>
                        <div class="col-md-12">
                            <span class="color-red"></span> Số câu sai: {{ countQuestionFalse }}
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="col-md-2 question-item-number" @click="handleClickQuestion(item)"
                                :class="{ 'is-true': item.isTrue, 'is-false': !item.isTrue }"
                                v-for="(item, index) of this.dataUserWork" :key="index">
                                {{ item.questionNumber }}
                            </div>
                        </div>


                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h5 v-if="!this.isShowResult">Thông tin đề</h5>
                        </div>
                        <div class="row col-md-12 wrap-point-feedback display-flex">
                            <div class="col-md-4 text-center">
                                <strong>Tổng điểm</strong>

                            </div>
                            <div class="col-md-8">
                                <strong class="result-point">{{ formatNumber(userExcerciseClassSchool.point) }}</strong>
                            </div>
                            <!-- <div @click="handleShowMoreInfo" class="col-md-12 text-end show-more">
                                {{!isShowMoreInfo?'Hiện thêm':'Ẩn bớt'}} <img class="icon-show-more" width="15px" src="@/assets/img/show-more-down.png" />
                            </div> -->
                            <b-collapse class="row col-md-12" :visible="isShowMoreInfo">
                                <div class="col-md-12 font-size-13">
                                    Lời phê:
                                </div>
                                <div class="col-md-12 wrap-feedback-teacher">
                                    <strong v-html="userExcerciseClassSchool.feedback"></strong>
                                </div>
                                <p></p>
                                <!-- <div class="col-md-12">
                                    <span class="font-size-13">Số câu đúng: </span><strong>{{ countQuestionTrue
                                        }}</strong>
                                </div>
                                <div class="col-md-12">
                                    <span class="font-size-13">Số câu sai: </span><strong>{{ countQuestionFalse
                                        }}</strong>
                                </div> -->
                                <div class="col-md-12">
                                    <span class="font-size-13">Thời gian hoàn thành: </span><strong>{{
                                        formatTimeResult() }}</strong>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                    <div class="row wrap-list-question">
                        <div @click="handleClickQuestion(item)" :class="{ 'is-choose': itemSelected.id == item.id }"
                            class="col-md-2 question-item-number" v-for="(item, index) of dataUserWork" :key="index">
                            {{ index + 1 }}
                        </div>
                    </div>
                    <div v-if="itemSelected.id" class="row margin-top-10">
                        <div class="col-md-12">
                            <h5>Câu {{ itemSelected.questionNumber }}: {{ formatNumber(itemSelected.pointTeacherFill)
                                }}/{{
                                    formatNumber(itemSelected.maxPoint) }} điểm</h5>
                        </div>
                        <!-- <strong>Câu trả lời học sinh:</strong>
                        <div class="wrap-answer col-md-12">
                            <div v-html="itemSelected.answerUserFill">

                            </div>
                            <div class="answer-item">

                            </div>

                        </div>
                        <p></p> -->
                        <strong class="feed-back-teacher-item">Nhận xét giáo viên:</strong>
                        <div class="wrap-answer ">
                            <div v-if="itemSelected.feedback" class="fit-max-height" v-html="itemSelected.feedback">

                            </div>
                            <div v-else>
                                Giáo viên không nhận xét câu trả lời này.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <ModalSubmitExcercise :textNotitySubmit="textNotitySubmit" v-if="isOpenModalSubmitExcercise"
            @handleSubmit="handleSubmit" @closeModal="closeModalSubmitExcercise" />
        <ModalTimeOutExcercise v-if="isOpenModalTimeOutExcercise" @closeModal="closeModalTimeOutExcercise" />
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import MultipleChoiceNew from './../../../../question/preview-question/answers/multiple-choice/MultipleChoiceNew.vue'
import { saveUserExcerciseClassSchool, submitExcerciseQuestionMixedWord } from './../../../_api/userExcerciseClassSchool';
import PreviewQuestion from '@/modules/question/preview-question-excercise-thieu/PreviewQuestion.vue'
import ModalSubmitExcercise from './ModalSubmitExcercise'
import EditorCKNew from '@/components/EditorCKNew.vue'
import ModalTimeOutExcercise from './ModalTimeOutExcercise'
const correct = require('@/assets/audio/correct.mp3')
const incorrect = require('@/assets/audio/incorrect.mp3')
import store from '@/modules/question/preview-question-excercise-thieu/_store'

import { STORE_KEY as STORE_KEY_QUESTION, TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL } from '@/modules/question/preview-question-excercise-thieu/_store/constants'
export default {
    components: {
        MultipleChoiceNew,
        ModalSubmitExcercise,
        EditorCKNew,
        ModalTimeOutExcercise,
        PreviewQuestion
    },
    props: {
        dataDetailExcercise: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        userExcerciseClassSchool: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },

        listUserExcerciseAnswerQuestion: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: []
        }
    },
    data() {
        return {
            correct,
            incorrect,
            actionPlayQuestionTrue: false,
            typeGroup: TYPE_GROUP,
            typeDrawShape: TYPE_DRAW_SHAPE_ANSWER,
            typeDownAnswer: TYPE_DOWN_ANSWER,
            typefillBlank: TYPE_FILL_BLANK,
            typeSelect: TYPE_SELECT,
            typeMatchCol: TYPE_MATH_COL,
            isShowMoreInfo: true,
            TYPE_RADIO: 'radio',
            TYPE_CHECKBOX: 'checkbox',
            TYPE_TRUE_FALSE_NO: 'answer_t_f_no',
            TYPE_MATH_COL: 'math_col',
            TYPE_FILL_BLANK: 'fill_blank',
            TYPE_FILL_SENTENCE: 'fill_sentence',
            TYPE_SELECT: 'select',
            TYPE_DOWN_ANSWER: 'down_answer',
            TYPE_CIRCLE_ANSWER: 'circle_answer',
            TYPE_X_MARK: 'x_mark_answer',
            TYPE_DRAW_SHAPE_ANSWER: 'draw_shape_answer',
            TYPE_GROUP: 'group',
            TYPE_FILL_INPUT_IMG: 'fill_input_img',
            dataUserWork: [],
            itemSelected: null,
            questionSelected: null,
            myInterval: null,
            secondTotal: 0,
            isSubmitExcercise: true,
            isOpenModalSubmitExcercise: false,
            textNotitySubmit: '',
            isShowResult: false,
            countQuestionTrue: 0,
            countQuestionFalse: 0,
            listQuestion: [],
            isSaveData: false,
            statusSave: 1,
            myIntervalAutoSave: null,
            dem: 3,
            statusUserExcercise: 0,
            isOpenModalTimeOutExcercise: false,
        }
    },
    created() {
        if (!(STORE_KEY_QUESTION in this.$store._modules.root._children)) {
            this.$store.registerModule(STORE_KEY_QUESTION, store);
        }
       
    },
    mounted() {
        this.listQuestion = this.dataDetailExcercise.listExcerciseQuestionClassSchool
        this.innitData()
        this.saveDataInterval()
    },
    methods: {
        ...mapActions('common', ['setLoading', 'setToggleModalActivePage', 'acSetDataBookActiveWant', 'acToggleModalActiveBook', 'acToggleModaShowHelp', 'actionCheckRouterHelp', 'actionGetVideoHelp', 'acToggleModaShowError', 'actionSetBookIndexId', 'actionSetBookIdForError', 'setActionCheckQuestion', 'actionSetPageNoBook', 'actionCheckExcercise', 'actionCheckInfoExcercise', 'actionCheckPage']),
        ...mapActions('auth', ['setToggleLoginForm']),
        ...mapActions(STORE_KEY_QUESTION, ['setVituralKeyVal', 'setQuestionData4CheckAnswer', 'setQuestionList4CheckAnswer']),
        getResultQuestion(data) {
            // if(this.isNotSave){
            //     this.isNotSave = false
            //     console.log('stoppp')
            //     return
            // }
            if (data.questionWork.isTrue) {
                this.itemSelected.isTrue = true
            }
            else {
                this.itemSelected.isTrue = false
            }
            if (!this.isShowResult) {
                this.itemSelected.listAnswer = []
                for (let i = 0; i < data.questionWork.answers.length; i++) {
                    const element = data.questionWork.answers[i];
                    this.itemSelected.listAnswer.push({
                        answerContent: element.answerContent,
                        answerId: element.answerId,
                        content: element.content,
                        isError: element.isError,
                        position: element.position,
                        questionId: element.questionId,
                        validateString: element.validate ? element.validate.join('#') : null,
                        validateValString: element.validateVal ? element.validateVal.join('#') : null,
                        excerciseQuestionId:this.itemSelected.excerciseQuestionClassSchoolId
                    })
                }

                this.handleChangeAnswer()
            }

        },
        writedAnswer(data) {
            this.itemSelected.valCorrect = []
            this.checkAnswer()
            this.itemSelected.valCorrect = data.answers
            if(data.answers && data.answers.length>0){
                this.itemSelected.valCorrectString = JSON.stringify(data.answers) 
            }
            
        },

        async checkAnswer() {
            console.log('checkAnswer')
            let self = this;
            self.resetValKeyboard()
            if (self.questionSelected.type !== this.typeDownAnswer) {
                self.setQuestionList4CheckAnswer([{ ...self.questionSelected }])
                self.setQuestionData4CheckAnswer({ ...self.questionSelected })
            }

            if (self.questionSelected.type === this.typeGroup) {
                self.txtMissingQuestionGroup = '';
                self.setQuestionData4CheckAnswer({ ...self.questionSelected, isGroup: true, parent: parent.questionId })
            }

            if (self.questionSelected.type !== this.typeDownAnswer) {
                await self.setActionCheckQuestion(true);
            } else {
                self.questionSelected = { ...self.questionSelected, isTrue: true }
                self.saveQuestion2Local(self.questionSelected)
            }
            //this.questionSelected.isWorked =true
        },
        changeAnswerEdittorCK(data) {
            if (this.isShowResult || !this.isSubmitExcercise) {
                return
            }
            if (this.questionSelected.type == this.TYPE_DOWN_ANSWER) {
                this.itemSelected.listAnswer = []

                if (data.answerContent && data.answerContent != '<p><br></p>') {
                    this.itemSelected.listAnswer.push({
                        answerId: data.answerId,
                        answerContent: data.answerContent,
                        isUserFillTrue: false,
                        questionId: data.questionId,
                        excerciseQuestionId:this.itemSelected.excerciseQuestionClassSchoolId
                    })
                    this.handleChangeAnswer()
                }
            }
        },
        setResultQuestionsSlider(value = true) {
            if (this.questionindexActive > 0) {
                this.sliderQuestionList[this.questionindexActive - 1]['isWorked'] = true
                this.sliderQuestionList[this.questionindexActive - 1]['isTrue'] = value
            }
            if (this.authInfo && this.authInfo.email === EMAIL_PUBLIC && this.sliderQuestionList.length > 0) {
                this.setResultQuestionForSidebarOfAccFree()
            } else if (this.keySidebarActive === 'info') {
                this.questionIdCheckAnswer = { value, id: this.sliderQuestionList[this.questionindexActive - 1].questionId }
            }
        },
        async setResultQuestionForSidebarOfAccFree() {
            let questionCorrect = 0
            let questionInCorrect = 0
            let questionNotDone = 0
            await this.sliderQuestionList.map(ques => {
                if (ques.isWorked && ques.isTrue) {
                    questionCorrect += 1
                } else if (ques.isWorked && !ques.isTrue) {
                    questionInCorrect += 1
                } else {
                    questionNotDone += 1
                }
            })

            this.questionIdCheckAnswer = { ...this.questionIdCheckAnswer, questionCorrect, questionInCorrect, questionNotDone }
        },
        resetValKeyboard() {
            this.valVituralKeyboard && this.setVituralKeyVal({});
        },
        formatNumber(value) {
            if (typeof value !== 'number') {
                return value;
            }
            return value.toFixed(2);
        },
        onEditorChangeAnswer(e) {
            if (this.userExcerciseClassSchool && this.userExcerciseClassSchool.status > 0) {
                return
            }
            if (this.statusUserExcercise == 0) {
                this.itemSelected.answer = e.html
                this.handleChangeAnswer()
            }

        },
        handleChangeAnswer() {
            this.dem = 3
            this.statusSave = 2
            this.isSaveData = true
        },
        saveDataInterval() {
            let self = this
            this.myIntervalAutoSave = setInterval(() => {
                self.dem--
                if (self.dem == 0 && self.isSaveData) {
                    self.dem = -1
                    console.log('Lưu data')
                    let dataSend = [...self.dataUserWork]
                    let listDataSave = []
                    for (let i = 0; i < dataSend.length; i++) {
                        const item = dataSend[i];
                        item.answer = item.answer
                        if (item.answer|| item.listAnswer.length>0) {
                            listDataSave.push(item)
                        }
                    }
                    let timeSubmit = (self.dataDetailExcercise.minuteExcercise * 60) - self.secondTotal

                    let params = {
                        type: 1,
                        lessonClassSchoolId: self.dataDetailExcercise.id,
                        classSchoolId: self.userExcerciseClassSchool.classSchoolId,
                        userExcercisId: self.userExcerciseClassSchool.id,
                        typeUploadExcercise: self.dataDetailExcercise.typeUploadExcercise,
                        listDataUserWorkPdf: listDataSave,
                        timeSubmit: timeSubmit
                    }
                    submitExcerciseQuestionMixedWord(params).then((res) => {
                        self.statusSave = 3
                        self.isSaveData = false
                    })
                }
            }, 1000)
        },
        innitData() {

            this.countQuestionTrue = 0
            this.countQuestionFalse = 0
            this.dataUserWork = []

            let listStringIsCheck = ''
            if (this.userExcerciseClassSchool) {
                listStringIsCheck = this.userExcerciseClassSchool.listCheckQuestion
            }

            let listCheck = []
            if (listStringIsCheck) {
                let arrayTemp = listStringIsCheck.split(',')
                for (let i = 0; i < arrayTemp.length; i++) {
                    listCheck.push(Number(arrayTemp[i]) == 1 ? true : false)

                }
            }
            for (let i = 0; i < this.listQuestion.length; i++) {
                const item = this.listQuestion[i];
                this.dataUserWork.push({
                    id: item.id,
                    excerciseQuestionClassSchoolId: item.id,
                    questionNumber: i + 1,
                    isCheck: listCheck.length > 0 ? listCheck[i] : false,
                    answer: '',
                    isTrue: false,
                    listAnswer: [],
                    valCorrect: [],
                    valCorrectString:'',
                    type:item.type
                })
                if (i == 0) {
                    this.questionSelected = item
                }
                if (i == 0) {
                    this.itemSelected = this.dataUserWork[0]

                }
            }
            if (this.listUserExcerciseAnswerQuestion && this.listUserExcerciseAnswerQuestion.length > 0) {
                //hiển thị thông tin 
                for (let i = 0; i < this.listUserExcerciseAnswerQuestion.length; i++) {
                    const item = this.listUserExcerciseAnswerQuestion[i];
                    for (let j = 0; j < this.dataUserWork.length; j++) {
                        let element = this.dataUserWork[j];
                        if (item.excerciseQuestionId == element.id) {
                            element.isTrue = item.isTrue
                            element.answerContent = item.answerContent
                            element.answerUserFill = item.answerUserFill
                            element.answer = item.answerUserFill
                            element.feedback = item.feedback
                            element.pointTeacherFill = item.pointTeacherFill
                            element.maxPoint = item.maxPoint
                            element.numberQuestion = item.numberQuestion
                            element.valCorrect =  item.valCorrectString?JSON.parse(item.valCorrectString):[]
                            element.listAnswer = item.listAnswer?item.listAnswer:[]
                        }
                    }
                }
                console.log(this.dataUserWork)
                if(this.questionSelected.type == this.typeMatchCol){
                    setTimeout(() => {
                        this.$refs.PreviewQuestion.reLoadData()
                    }, 1000);
                }
            }
            if (this.listUserExcerciseAnswerQuestion && this.listUserExcerciseAnswerQuestion.length > 0 && (this.userExcerciseClassSchool.status == 2 || this.userExcerciseClassSchool.status == 5)) {
                //hiển thị thông tin 
                this.statusUserExcercise = 1
                this.isShowResult = true
                for (let i = 0; i < this.listUserExcerciseAnswerQuestion.length; i++) {
                    const item = this.listUserExcerciseAnswerQuestion[i];
                    console.log(item)
                    if (item.isTrue) {
                        this.countQuestionTrue++
                    }
                    else {
                        this.countQuestionFalse++
                    }

                    ///
                    for (let j = 0; j < this.dataUserWork.length; j++) {
                        let element = this.dataUserWork[j];
                        if (item.excerciseQuestionId == element.id) {
                            element.isTrue = item.isTrue
                            element.answerContent = item.answerContent
                            element.answerUserFill = item.answerUserFill
                            element.answer = item.answerUserFill
                            element.feedback = item.feedback
                            element.pointTeacherFill = item.pointTeacherFill
                            element.maxPoint = item.maxPoint
                            element.numberQuestion = item.numberQuestion
                            element.valCorrect =  item.valCorrectString?JSON.parse(item.valCorrectString):[]
                            element.listAnswer = item.listAnswer?item.listAnswer:[]
                        }
                    }
                }
                this.handleClickQuestion(this.itemSelected)
                return
            }


            for (let i = 0; i < this.listUserExcerciseAnswerQuestion.length; i++) {
                const item = this.listUserExcerciseAnswerQuestion[i];
                for (let j = 0; j < this.dataUserWork.length; j++) {
                    let element = this.dataUserWork[j];
                    if (item.excerciseQuestionId == element.id) {
                        element.answer = item.answerUserFill
                        // element.answerContent = item.answerContent
                        break
                    }
                }
            }
            if (this.userExcerciseClassSchool && this.userExcerciseClassSchool.status > 0) {
                this.isSubmitExcercise = false
                return
            }
            // sét thời gian
            if (this.userExcerciseClassSchool) {
                let datetimeStartDoWork = new Date(this.userExcerciseClassSchool.timeStartDoExcercise)

                let timeDiff = new Date(this.userExcerciseClassSchool.timeCurrent).getTime() - datetimeStartDoWork.getTime();

                let secondsDiff = timeDiff / 1000;
                if (secondsDiff > this.dataDetailExcercise.minuteExcercise * 60) {
                    console.log('Hết thời gian')
                    //this.isSubmitExcercise = false
                }
                else {
                    this.secondTotal = (this.dataDetailExcercise.minuteExcercise * 60) - parseInt(secondsDiff)

                    this.initInterval()
                }
            }
            else {
                this.isSubmitExcercise = false
                this.$router.push('/')
            }

        },
        formatTimeResult() {
            let hours = Math.floor(this.userExcerciseClassSchool.timeComplete / 3600); // Lấy phần nguyên khi chia cho 3600
            let minutes = Math.floor((this.userExcerciseClassSchool.timeComplete % 3600) / 60); // Lấy phần nguyên của phần dư khi chia cho 3600, sau đó chia cho 60
            let seconds = this.userExcerciseClassSchool.timeComplete % 60;

            if (hours > 0) {
                return `${hours} giờ ${minutes} phút ${seconds < 10 ? `0${seconds}` : `${seconds}`} giây`;
            } else if (minutes > 0) {
                return `${minutes} phút ${seconds < 10 ? `0${seconds}` : `${seconds}`} giây`;
            } else {
                return `${seconds} giây`;
            }
        },
        handleSubmit(isSaveAuto) {
            this.closeModalSubmitExcercise()
            let self = this
            //format câu trả lời
            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                item.answer = item.answer
            }
            let timeSubmit = (this.dataDetailExcercise.minuteExcercise * 60) - this.secondTotal

            let params = {
                type: 2,
                lessonClassSchoolId: this.dataDetailExcercise.id,
                classSchoolId: this.userExcerciseClassSchool.classSchoolId,
                userExcercisId: this.userExcerciseClassSchool.id,
                typeUploadExcercise: this.dataDetailExcercise.typeUploadExcercise,
                listDataUserWorkPdf: this.dataUserWork,
                timeSubmit: timeSubmit
            }
            submitExcerciseQuestionMixedWord(params).then((res) => {
                if (!isSaveAuto) {
                    self.$toast.success('Nộp bài thành công')
                    self.$emit('handleReloadDetailData')
                }
            })
        },
        closeModalSubmitExcercise() {
            this.isOpenModalSubmitExcercise = false
        },
        closeModalTimeOutExcercise() {
            this.isOpenModalTimeOutExcercise = false
            this.$emit('handleReloadDetailData')
        },
        handSubmitExcercise() {
            //kiểm tra
            let isFillAllAnswer = true
            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                if (!item.answer) {
                    isFillAllAnswer = false
                    break
                }
            }
            if (isFillAllAnswer) {
                this.textNotitySubmit = 'Bạn có chắc chắn muốn nộp bài'
            }
            else {
                this.textNotitySubmit = 'Hiện vẫn còn 1 số câu chưa làm. Bạn có chắc chắn muốn nộp bài luôn?'
            }
            this.isOpenModalSubmitExcercise = true
        },
        beforeDestroy() {
            if (this.myInterval) {
                clearInterval(this.myInterval)
            }
            if (this.myIntervalAutoSave) {
                clearInterval(this.myIntervalAutoSave)
            }
        },
        changeAnswer(e, data) {
            let self = this
            console.log(this.questionSelected, data.location)
            let answerItem = this.questionSelected.answers[data.location]

            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                if (item.id == answerItem.excerciseQuestionId) {
                    item.answer = answerItem.content
                    break
                }
            }

            this.handleChangeAnswer()
        },
        handleNextquestion() {
            this.questionSelected = null
            let indexNext = 0
            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                if (item.id == this.itemSelected.id) {
                    indexNext = i + 1
                    if (indexNext >= this.dataUserWork.length) {
                        indexNext = 0
                    }
                    break
                }
            }
            this.itemSelected = this.dataUserWork[indexNext]


            for (let i = 0; i < this.listQuestion.length; i++) {
                const item = this.listQuestion[i];
                // eslint-disable-next-line no-cond-assign
                if (item.id == this.itemSelected.id) {
                    this.questionSelected = item
                    break
                }
            }
        },
        handlePrevQuestion() {
            this.questionSelected = null
            let indexNext = 0
            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                if (item.id == this.itemSelected.id) {
                    indexNext = i - 1
                    if (indexNext < 0) {
                        indexNext = this.dataUserWork.length - 1
                    }
                    break
                }
            }
            this.itemSelected = this.dataUserWork[indexNext]


            for (let i = 0; i < this.listQuestion.length; i++) {
                const item = this.listQuestion[i];
                // eslint-disable-next-line no-cond-assign
                if (item.id == this.itemSelected.id) {
                    this.questionSelected = item
                    console.log(item)
                    break
                }
            }
        },
        handleCheckItem() {
            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                if (item == this.itemSelected) {
                    // code cũ
                    // item.isCheck = true
                    // code mới -> click lần 2 thì bỏ đánh dấu
                    item.isCheck = !item.isCheck
                }
            }
            this.updateIsCheckQuestion()
        },
        updateIsCheckQuestion() {
            let listCheck = []
            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                listCheck.push(item.isCheck ? 1 : 0)
            }

            let params = {
                statusId: 2,
                lessonClassSchoolId: this.userExcerciseClassSchool.lessonClassSchoolId,
                classSchoolId: this.userExcerciseClassSchool.classSchoolId,
                listCheckQuestion: listCheck.join(',')
            }
            saveUserExcerciseClassSchool(params).then((res) => {
                if (res && res.data && !res.errors) {
                    console.log(res.data)
                }
            })
        },

        initInterval() {
            let self = this
            this.myInterval = setInterval(() => {
                this.secondTotal--
                if (this.secondTotal <= 0) {
                    this.isSubmitExcercise = false
                    clearInterval(self.myInterval)
                    ///
                    this.handleSubmit(true)
                    this.isOpenModalTimeOutExcercise = true
                }
            }, 1000)
        },
        formatTime() {
            let minutes = Math.floor(this.secondTotal / 60); // Lấy phần nguyên khi chia cho 60
            let seconds = this.secondTotal % 60;
            if (minutes > 0) {
                return `${minutes}:${seconds}`
            }
            return `${seconds}`
        },
        handleClickQuestion(questionCurrent) {
            this.questionSelected = null
            for (let i = 0; i < this.listQuestion.length; i++) {
                const item = this.listQuestion[i];
                if (questionCurrent.id == item.id) {
                    this.questionSelected = item
                    break
                }
            }
            this.itemSelected = questionCurrent
            if (this.dataDetailExcercise.typeUploadExcercise == 4) {
                //lấy ra điểm max
                for (let i = 0; i < this.dataDetailExcercise.listExcerciseQuestionClassSchool.length; i++) {
                    const element = this.dataDetailExcercise.listExcerciseQuestionClassSchool[i];
                    if (element.id == this.itemSelected.id) {
                        this.itemSelected.maxPoint = element.point
                        break
                    }
                }
            }
            if(this.questionSelected.type == this.typeMatchCol){
                    setTimeout(() => {
                        this.$refs.PreviewQuestion.reLoadData()
                    }, 1000);
                }
        }
    }
}

</script>
<style lang="scss" scoped>
.fit-max-height {
    min-height: 2rem;
}

.wrap-point-feedback {
    border: 1px solid gray;
    margin-left: 5px;
    border-radius: 15px;
}

.wrap-feedback-teacher {
    max-height: 10rem;
    overflow: auto;
    padding: 10px;
}

.feed-back-teacher-item {
    margin-top: 10px;
}

.wrap-answer {
    border: 1px solid #5f7dcc;
    border-radius: 10px;
    max-height: 10rem;
    overflow: auto;
    padding: 5px;
    min-height: 2rem;
    width: 100%;
}

.margin-top-10 {
    margin-top: 10px
}

.is-true {
    background: #00ac5d !important;
    color: white !important;
    border-radius: 10px;
    text-align: center;
}

.is-false {
    background: #ff4953 !important;
    color: white !important;
    border-radius: 10px;
    text-align: center;
}

.is-choose {
    border: 2px solid blue;
}

.textarea-input-answer {
    border-radius: 15px;
    border: 1px solid gray;
    width: 100%;
    padding: 10px;
}

.result-point {
    font-size: 50px;
    font-family: ui-monospace;
    font-style: italic;
    color: red;
}

.wrap-content-question {
    border: 2px solid #91a3dc;
    padding: 10px;
    border-radius: 10px;
}

.margin-top-10 {
    margin-top: 10px;
}

.icon-arrow {
    width: 10px;
    height: 20px;
    margin-top: 5px;
    cursor: pointer;
}

.btn-ischeck {
    background: orange;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    color: white
}

.question-item-number {
    width: 100%;
    background: #b7ddf9;
    border-radius: 10px;
    color: blue;
    display: inline-block;
    text-align: center;
    margin-left: 5px;
    margin-top: 10px;
    cursor: pointer;
}

.is-true {
    background: #00ac5d;
    color: white;
    border-radius: 10px;
    text-align: center;
}

.is-false {
    background: #ff4953;
    color: white;
    border-radius: 10px;
    text-align: center;
}

.color-blue {
    width: 10px;
    height: 10px;
    display: inline-block;
    background: green;
    border-radius: 20px;
}

.color-red {
    width: 10px;
    height: 10px;
    display: inline-block;
    background: red;
    border-radius: 20px;
}

.is-check {
    background: #ff832b !important;
    color: white !important;
}

.btn-check {
    background: #ff832b;
    color: white;
    line-height: 18px;
}

.is-fill {
    background-color: blue !important;
    color: white !important;
}

.is-choose {
    border: 2px solid blue;
}

.display-flex-center {
    text-align: center;
    align-items: center;
    justify-content: center;
}
</style>
<style lang="scss" scoped>
.title-complete {}

.time-complete {}



.list-result-number {
    .result-item-number {
        .result-number {
            color: #2100af;
            font-size: 20px;
            font-weight: 600;
        }

        .result-user-fill {
            color: red;
            font-size: 20px;
            font-weight: 600;
        }

        .result-answer {
            color: green;
            font-size: 20px;
            font-weight: 600;
        }
    }
}
